import React from 'react';
import Educ from './Educ';
import './resume.css';


const Cv = () => {
  return (
    <div>
      <Educ/>
    </div>
  )
}

export default Cv